// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/insa-components/insa-generic-form/generic-grid/generic-grid.css
// module id = 1851
// module chunks = 2